import { PageNotFound } from '@components/PageNotFound';
import { PermissionDeny } from '@components/PermissionDeny';
import { DefaultLayout } from '@layouts/DefaultLayout';
import { HomeLayout } from '@layouts/HomeLayout';
import { Layouts } from '@layouts/Layouts';
import { PermissionLayout } from '@layouts/PermissionLayout';
import { Home } from 'pages/Home';
import { ApiManual } from 'pages/api-manual';
import { DirectoryDownloadConfig } from 'pages/directory-download-config';
import { ConfigPage } from 'pages/directory-download-config/ConfigPage';
import { DirectoryManagement } from 'pages/directory-management';
import { DirectoryPreview } from 'pages/directory-preview';
import { DirectoryService } from 'pages/directory-service';
import { DownloadConfig } from 'pages/download-config';
import { DownloadService } from 'pages/download-service';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { withMenuAccess } from '@helpers/with-menu-access';
import CheckAccessTimeRoute from './CheckAccssTimeRoute';

// Every route is wrapped in withMenuAccess as well as CheckAccessTimeRoute. The two ask different
// questions: withCheckAccessTime asks the API whether the menu is inside its operating HOURS - it never
// receives the caller - while withMenuAccess asks whether this user holds the menu at all. Without the
// second, putting any valid menuId in the URL rendered any screen, including the administrator ones.
const routes = [
  {
    path: '/api-manual',
    exact: true,
    component: withMenuAccess(ApiManual),
  },
  {
    path: '/download-service',
    exact: true,
    component: withMenuAccess(DownloadService),
  },
  {
    path: '/download-config',
    exact: true,
    component: withMenuAccess(DownloadConfig),
  },
  {
    path: '/directory-service',
    exact: true,
    component: withMenuAccess(DirectoryService),
  },
  {
    path: '/directory-management',
    exact: true,
    component: withMenuAccess(DirectoryManagement),
  },
  {
    path: '/directory-preview',
    exact: true,
    component: withMenuAccess(DirectoryPreview),
  },
  {
    path: '/directory-download-config',
    exact: true,
    component: withMenuAccess(DirectoryDownloadConfig),
  },
  {
    path: '/directory-download-config/form/:configName',
    exact: true,
    component: withMenuAccess(ConfigPage),
  },
  {
    path: '/directory-download-config/form/',
    exact: true,
    component: withMenuAccess(ConfigPage),
  },
];

export const Routers: React.FC = () => (
  <Switch>
    <Route path={['/auth', '/']} exact>
      <Layouts layout={HomeLayout} isPublic={true}>
        <Route component={Home} />
      </Layouts>
    </Route>

    <Layouts layout={DefaultLayout} isPublic={true}>
      {routes.map((r) => {
        return (
          <CheckAccessTimeRoute
            key={r.path}
            path={r.path}
            component={r.component}
            exact={r.exact}
          />
        );
      })}
      <Route path={'/error/access'} exact component={PermissionDeny} />
    </Layouts>

    <Route path="*">
      <Layouts layout={PermissionLayout} isPublic={true}>
        <Route component={PageNotFound} />
      </Layouts>
    </Route>
  </Switch>
);

export default routes;
